<template>
  <div
    class="min-h-screen lg:h-screen w-full bg-white flex flex-col lg:flex-row lg:overflow-hidden"
  >
    <div
      class="w-full lg:w-1/2 lg:h-screen lg:overflow-y-auto flex items-center justify-center px-6 py-8 lg:px-12 lg:py-6"
    >
      <div class="w-full max-w-xl">
        <div class="flex items-center justify-center flex-wrap gap-4 mb-4">
          <button
            type="button"
            title="Go to Coach Catalyst signup"
            class="focus:outline-none"
            @click="goToCoachCatalyst"
          >
            <Logo type="LONG" class="h-8 w-auto cursor-pointer" />
          </button>
          <span
            class="w-6 h-6 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-sm text-gray-400"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
          </span>
          <img :src="gcLogo" class="h-6 w-auto" alt="Growth Catalyst" />
        </div>

        <div class="w-6 h-0.5 bg-cc-green-500 mx-auto mb-4"></div>

        <slot />
      </div>
    </div>

    <div
      class="hidden lg:flex w-full lg:w-1/2 h-screen items-center justify-center"
    >
      <img
        class="w-full h-full max-h-screen object-contain p-6"
        :src="signupImage"
        alt="Signup"
      />
    </div>
  </div>
</template>

<script>
  import Logo from '../../../components/logos/Logo.vue';

  export default {
    name: 'BundleSignupShell',
    components: { Logo },
    data() {
      return {
        gcLogo: require('images/growth_catalyst_logo.png'),
        signupImage: require('images/signup_image.webp'),
      };
    },
    methods: {
      goToCoachCatalyst() {
        window.location.href = '/auth/sign_up';
      },
    },
  };
</script>
